export enum OrganizationRole {
    Hosts = 'hosts',
    Participants = 'participants',
    Presenters = 'presenters',
    Supports = 'supports',
    Registrants = 'registrants',
}
